<div class="row align-items-center mb-3 g-2">
  <div class="col-12 col-md-8 col-lg-9">
    <mat-form-field appearance="outline" class="w-100 search-field mb-0">
      <mat-label>Search by Serial Number, Product Code, Customer, City...</mat-label>
      <input
        matInput
        (keyup)="onSearch($event)"
        placeholder="Enter Serial #, Barcode, QR Code, Product SKU, Customer Name..."
        #searchInput
      />
      <button
        *ngIf="searchInput.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearSearch(searchInput)"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-icon *ngIf="!searchInput.value" matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <div class="col-12 col-md-4 col-lg-3 text-md-end">
    <button
      mat-raised-button
      color="primary"
      (click)="exportToCsv()"
      [disabled]="spinner || totalRecords === 0"
      class="w-100 w-md-auto export-btn"
    >
      <mat-icon class="align-middle me-1">download</mat-icon>
      Export CSV
    </button>
  </div>
</div>

<mat-card class="w-100 shadow-sm border-0">
  <mat-card-content class="p-3">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
      <div class="d-flex align-items-center gap-2">
        <mat-icon class="text-primary fs-3 align-middle">how_to_reg</mat-icon>
        <mat-card-title class="m-0 fs-5 fw-bold text-dark">Registered Products</mat-card-title>
      </div>
      <div class="d-flex align-items-center gap-2">
        <span class="badge bg-primary fs-6 px-3 py-2" *ngIf="!spinner">
          Total Registered: {{ totalRecords }}
        </span>
      </div>
    </div>

    <div class="spinner text-center py-5" *ngIf="spinner">
      <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
      <p class="text-muted mt-2">Loading registered products...</p>
    </div>

    <div [hidden]="spinner" class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="text-nowrap w-100 modern-table" matSort>

        <!-- Serial / Code Column -->
        <ng-container matColumnDef="productCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Serial / Code</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex flex-column">
              <span class="fw-bold text-primary font-monospace fs-6">{{ element.productCode }}</span>
              <div class="d-flex align-items-center gap-1 mt-1" *ngIf="element.serialNumber">
                <span class="badge bg-light text-dark border">
                  Seq #{{ element.serialNumber }}
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Product Column -->
        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th>
          <td mat-cell *matCellDef="let element">
            <div class="fw-semibold text-dark">{{ element.productName }}</div>
            <div class="text-muted small d-flex align-items-center gap-2">
              <span *ngIf="element.productSKU" class="badge bg-light text-secondary border">SKU: {{ element.productSKU }}</span>
              <span *ngIf="element.categoryName">{{ element.categoryName }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Registered Date Column ("When") -->
        <ng-container matColumnDef="registeredDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>When Registered</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center text-dark">
              <mat-icon class="text-muted inline-icon me-1">event</mat-icon>
              <span>{{ element.registeredDate | date : "dd MMM yyyy" }}</span>
            </div>
            <div class="text-muted small ps-4">
              {{ element.registeredDate | date : "hh:mm a" }}
            </div>
          </td>
        </ng-container>

        <!-- User / Who Registered Column ("Who") -->
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Who Registered</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.user; else noUser">
              <div class="fw-medium text-dark d-flex align-items-center">
                <mat-icon class="text-primary inline-icon me-1">person</mat-icon>
                {{ element.user.username }}
              </div>
              <div class="text-muted small ps-4" *ngIf="element.user.phone">
                <mat-icon class="inline-icon text-muted me-1">call</mat-icon>{{ element.user.phone }}
              </div>
              <div class="text-secondary small ps-4" *ngIf="element.user.companyName">
                {{ element.user.companyName }}
              </div>
            </div>
            <ng-template #noUser>
              <span class="text-muted fst-italic">Unknown User</span>
            </ng-template>
          </td>
        </ng-container>

        <!-- Location Column ("From Where") -->
        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>From Where</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.user && (element.user.city || element.user.state); else noLoc">
              <div class="fw-medium text-dark d-flex align-items-center">
                <mat-icon class="text-danger inline-icon me-1">location_on</mat-icon>
                <span>{{ element.user.city || '-' }}</span>
              </div>
              <div class="text-muted small ps-4">
                {{ element.user.state || '' }} <span *ngIf="element.user.pincode">({{ element.user.pincode }})</span>
              </div>
            </div>
            <ng-template #noLoc>
              <span class="text-muted">-</span>
            </ng-template>
          </td>
        </ng-container>


        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="text-center">Action</th>
          <td mat-cell *matCellDef="let element" class="text-center">
            <button
              mat-stroked-button
              color="primary"
              (click)="viewDetails(element)"
              aria-label="View Registration Details"
              class="details-btn"
            >
              <mat-icon class="align-middle me-1">visibility</mat-icon>
              Details
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hover-row"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center py-5" colspan="8">
            <div class="empty-state">
              <mat-icon class="empty-icon text-muted">search_off</mat-icon>
              <div class="text-muted fs-6 mt-2" *ngIf="searchInput.value">
                No registered products found matching "<strong>{{ searchInput.value }}</strong>"
              </div>
              <div class="text-muted fs-6 mt-2" *ngIf="!searchInput.value">
                No registered products recorded yet.
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalRecords"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[10, 25, 50, 100]"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Select page of registered products"
      class="mt-2"
    ></mat-paginator>
  </mat-card-content>
</mat-card>
